import getScenarioStore from '../selectors/getScenarioStore';
import { mutator } from 'satcheljs';
import { setSearchTextForSuggestion } from '../actions/publicActions';

export default mutator(setSearchTextForSuggestion, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).searchTextForSuggestion =
        actionMessage.searchTextForSuggestion;
});
